// index.js
import React from 'react'
import ReactDOM from 'react-dom'
import sha256 from 'js-sha256'

import { hashes, concatenated } from './hashes'
import logo from './logo.svg';

const startingIndex = 0;
const BearNBearContractAddress = '0xbD8724Ec4F1Bbf98ce0db8612dE67E0a192F798d';
const MiniBearContractAddress = '0xA5eb55A316aA589dc09ea63C7d53F6Ba44e23a21';

const Provenance = () => {
  const [list, setList] = React.useState([])
  React.useEffect(() => {
    const data = []
    const rows = hashes.split('\n').map(row=>row.split(','))
    // console.log({verified: rows.map(r => r[1]).join('') === concatenated})
    for(let row of rows){
      data[Number(row[0])] = {
        id: Number(row[0]),
        sha256: row[1],
        ipfs: row[2]
      }
    }
    setList(data.slice(1))
  }, [])

  return (
    <div>
      <div className='navbar-component'>
        <a href='http://thebearnbear.com' className='item site-title'>
          <img alt='logo' src={logo}/>
          BearNBear <span>| Provenance</span>
        </a>
      </div>
      <div className='banner'><a href='http://thebearnbear.com'>BearNBear</a> secured by <a href='https://www.binance.org/en/smartChain'>Binance Smart Chain</a> & <a href='https://ipfs.io/'>IPFS</a></div>
      <div className='body'>
        <h1>BearNBear Provenance Record</h1>
        <div>
          This page presents the provenance record of each BearNBear that will ever exist.
          <div>Each full resolution BearNBear original image is firstly hashed using SHA-256 algorithm. A combined string is obtained by concatenating SHA-256 of each Hashmask image in the specific order as listed below. The final proof is obtained by SHA-256 hashing this combined string.</div>
        </div>
        <div className='highlight-container'>
         <div>BearNBear Contract Address</div>
         {BearNBearContractAddress ? <div>{BearNBearContractAddress}</div> : <div>TBD (to be deployed)</div>}
         <div>MiniBear Contract Address</div>
         {MiniBearContractAddress ? <div>{MiniBearContractAddress}</div> : <div>TBD (to be deployed)</div>}
         <div>Finalized Starting Index</div>
         {startingIndex ? <div>{startingIndex}</div> : <div>TBD (to be determined when crowdsale ends)</div>}
        </div>
        <div className='highlight-container'>
          <div>Concatenated Hash String</div>
          <div className='wrap'>
            {concatenated}
          </div>
          <div>Art Work Final Proof Hash</div>
          <div className='wrap'>{sha256(concatenated)}</div>
        </div>
        <div className='secondary-container'>
          Each BearNBear tokenID is assigned to an artwork image from the original sequence by using this formula:<br/>
          <div className='math'>
            if tokenID is between 0 and 17149<br/>
            (tokenID + startingIndex) % 17149 + 1 => Image Index From the Original Sequence
          </div>
          <div className='math'>
            if tokenId is 17150, 17151,or 17152 <br/>
            (tokenID + 1) => Image Index From the Original Sequence
          </div>
        </div>
        <div className='list-body'>
          <b>
            <div>Initial Index - SHA-256 - IPFS HASH</div>
            {/*<div>Initial Index - SHA-256</div>*/}
          </b>
          {list.map((item)=>(<div className='item' key={item.sha256}>
            <span className='wrap'>{item.id}</span>
            <span className='wrap'>{item.sha256}</span>
            <a href={`https://ipfs.io/ipfs/${item.ipfs}`} target='_blank' rel='noopener noreferrer'><span className='wrap'>{item.ipfs}</span></a>
          </div>))}
        </div>
      </div>
    </div>
  )
}

ReactDOM.render(<Provenance />, document.getElementById('root'))
